exports.register = (module) ->
    module.factory 'Core.Services.MapLayers.Soil', [
        '$injector', ($injector) ->
            return {
                new: () ->
                    service = $injector.get('Core.Services.MapLayers.Base').new()
                    service.url = 'backend/grower/layers/soil/get'

                    return service
            }
    ]
